var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalLinkButton',{staticClass:"ta-auction-location-information-link",attrs:{"title":_vm.$t('Location Information'),"content":_vm.locationInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }